import React, { Component } from 'react'
import { BnApp } from '../App'
import { Me } from '../../classes/Me'
import { firebase, firebaseConfig } from './firebase'
import { setPortal, getPortal } from './portal'
import { getClientPlatformClassName } from './platformClassName'
import './index.css'

export { getPortal } from './portal'
export { installFirestoreV8PermissionDebug } from './firestorePermissionDebug'

const me = new Me(firebase, firebaseConfig)

export class BnClient extends Component {
  state = {}
  selfSubscription = null

  componentDidMount() {
    this.selfSubscription = me.observeSelf().subscribe(self => {
      this.setState({ self })
    })
  }

  componentWillUnmount() {
    if (this.selfSubscription) {
      this.selfSubscription.unsubscribe()
    }
  }

  setPortalRef = ref => {
    if (setPortal(ref)) {
      this.forceUpdate()
    }
  }

  render() {
    return (
      <div
        className={getClientPlatformClassName({ isNative: me.isNative() })}
        ref={this.setPortalRef}
      >
        <BnApp self={this.state.self} me={me} />
      </div>
    )
  }
}
